import React from 'react';
import CtaIcon from '../ui/CtaIcon';
import { Link } from 'react-router-dom';
import LikeBuildButton from '../LikeBuildButton';
import FavoriteBuildButton from '../FavoriteBuildButton';
/** Controllers provide state and callbacks; the card owns every action's markup and material. */
export interface CollectorActions {
  source?: { href?: string; onOpen?: () => void; label: string };
  vehicle?: {
    id: number;
    ownerUsername?: string;
    like?: {
      count?: number;
      selected?: boolean;
      onChange?: (selected: boolean, count: number) => void;
    };
    favorite?: {
      count?: number;
      selected?: boolean;
      onChange?: (selected: boolean, count: number) => void;
    };
  };
  edit?: () => void;
}
export default function CollectorActionControls({ actions }: { actions?: CollectorActions }) {
  const source = actions?.source;
  return (
    <>
      {actions?.vehicle?.like && (
        <LikeBuildButton
          vehicleId={actions.vehicle.id}
          initialLiked={actions.vehicle.like.selected}
          initialLikeCount={actions.vehicle.like.count}
          showCount={actions.vehicle.like.count != null}
          size="sm"
          onLikeChange={actions.vehicle.like.onChange}
        />
      )}
      {actions?.vehicle?.favorite && (
        <FavoriteBuildButton
          vehicleId={actions.vehicle.id}
          ownerUsername={actions.vehicle.ownerUsername}
          initialFavorited={actions.vehicle.favorite.selected}
          initialFavoriteCount={actions.vehicle.favorite.count}
          showCount={actions.vehicle.favorite.count != null}
          size="sm"
          onFavoriteChange={actions.vehicle.favorite.onChange}
        />
      )}
      {actions?.edit && (
        <button type="button" className="ct-edit" onClick={actions.edit}>
          Edit
        </button>
      )}
      {source &&
        (source.href ? (
          <Link className="collector-card__destination" to={source.href} onClick={source.onOpen}>
            <span>{source.label}</span>
            <CtaIcon compact />
          </Link>
        ) : (
          <button className="collector-card__destination" type="button" onClick={source.onOpen}>
            <span>{source.label}</span>
            <CtaIcon compact />
          </button>
        ))}
    </>
  );
}
